/* eslint-disable import/prefer-default-export */
import { InputFieldType } from "src/types/checkout";
import { CustomizationItem } from "src/types/customization";
import { StarterPriceType } from "src/types/starterPrice";
import { axiosErrorUnwrap } from "src/utils/axiosError";
import { EntryFormInputType } from "../types/entryForm";
import {
  MatchedPricingItem,
  MatchedPricingItemWithPlanCode,
  PlanType,
  StaterPriceWithPlanCode,
} from "../types/plan";
import { clientHttpInstance, serverHttpInstance } from "./http-client";
/**
 *get plan by code
 * @param code plan code
 * @param categoryCode cartegory code
 * @returns plan
 */
export const getPlanByCode = async (
  code: string,
  categoryCode: string,
  channelCode: string
): Promise<PlanType> => {
  try {
    const res = await clientHttpInstance.get<PlanType>(
      `/channels/${channelCode}/product-categories/${categoryCode}/plans/${code}`
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export type SearchPlanInput = {
  entryFormInputs: Partial<EntryFormInputType>;
};

export const searchPlan = async (
  channelCode: string,
  categoryCode: string,
  data: SearchPlanInput
): Promise<PlanType[]> => {
  const res = await clientHttpInstance.post<
    SearchPlanInput,
    { data: PlanType[] }
  >(
    `/channels/${channelCode}/product-categories/${categoryCode}/plans/search`,
    data
  );
  return res.data;
};

export const getPlanStarterPrice = async (
  channelCode: string,
  categoryCode: string,
  planCode: string
): Promise<StarterPriceType> => {
  try {
    const res = await serverHttpInstance.get(
      `/channels/${channelCode}/product-categories/${categoryCode}/plans/${planCode}/starter-price`
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export type GetPlanMatchedPricingItem = {
  entryFormInputs: Partial<EntryFormInputType>;
  customizations?: CustomizationItem[];
  priceImpactInputs?: InputFieldType[];
};

export const getPlanMatchedPricingItem = async (
  planCode: string,
  categoryCode: string,
  channelCode: string,
  entryFormInputs: Partial<EntryFormInputType>,
  customizations?: CustomizationItem[],
  priceImpactInputs?: InputFieldType[]
): Promise<MatchedPricingItem> => {
  try {
    const res = await clientHttpInstance.post<
      GetPlanMatchedPricingItem,
      { data: MatchedPricingItem }
    >(
      `/channels/${channelCode}/product-categories/${categoryCode}/plans/${planCode}/pricing`,
      {
        entryFormInputs,
        customizations,
        priceImpactInputs,
      }
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export type GetPlanWithPricingReqBody = {
  entryFormInputs: Partial<EntryFormInputType>;
};

export const getPlanWithPricing = async (
  planCode: string,
  categoryCode: string,
  channelCode: string,
  entryFormInputs: Partial<EntryFormInputType>
): Promise<PlanType> => {
  try {
    const res = await clientHttpInstance.post<
      GetPlanWithPricingReqBody,
      { data: PlanType }
    >(
      `/channels/${channelCode}/product-categories/${categoryCode}/plans/${planCode}`,
      {
        entryFormInputs,
      }
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export const getPlanGroup = async (
  channelCode: string,
  categoryCode: string,
  productCode: string
): Promise<Partial<PlanType>[]> => {
  try {
    const res = await serverHttpInstance.get(
      `/channels/${channelCode}/product-categories/${categoryCode}/products/${productCode}/plans`
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export const getStarterPricePlanGroup = async (
  channelCode: string,
  categoryCode: string,
  productCode: string
): Promise<Partial<StaterPriceWithPlanCode>[]> => {
  try {
    const res = await serverHttpInstance.get(
      `/channels/${channelCode}/product-categories/${categoryCode}/products/${productCode}/starter-price`
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

export const getProductMatchedPricingItem = async (
  productCode: string,
  categoryCode: string,
  channelCode: string,
  entryFormInputs: Partial<EntryFormInputType>
): Promise<MatchedPricingItemWithPlanCode[]> => {
  try {
    const res = await clientHttpInstance.post<
      GetPlanMatchedPricingItem,
      { data: any }
    >(
      `/channels/${channelCode}/product-categories/${categoryCode}/products/${productCode}/pricing`,
      {
        entryFormInputs,
      }
    );
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};
